import React from 'react';

import { Icon } from '../icons';

export const MCQIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" stroke={color} style={style} fill="transparent">
      <g>
        <path
          d="M4.15625 1.7608C4.0843 1.75366 4.01133 1.75 3.9375 1.75C2.72938 1.75 1.75 2.72938 1.75 3.9375C1.75 5.14562 2.72938 6.125 3.9375 6.125C4.99579 6.125 5.87856 5.37348 6.08124 4.375"
          strokeWidth="0.65625"
          strokeLinecap="round"
        />
        <circle cx="3.9375" cy="10.0625" r="2.1875" strokeWidth="0.65625" />
        <circle cx="10.0625" cy="3.9375" r="2.1875" strokeWidth="0.65625" />
        <circle cx="10.0625" cy="10.0625" r="2.1875" strokeWidth="0.65625" />
        <path
          d="M6.5625 1.75L4.04583 4.375L3.28125 3.71875"
          strokeWidth="0.65625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
